import type { VaultServerMessageRow } from "./authApi";
import {
  b64ToU8,
  decryptVaultMessage,
  TOMBSTONE_ENVELOPE_PLAINTEXT,
  vaultPeerKey,
} from "./crypto";
import type { MessageRow } from "./db";

export async function vaultServerRowsToMessageRows(
  vaultId: string,
  userId: string,
  rows: VaultServerMessageRow[],
  vaultKey: Uint8Array,
): Promise<MessageRow[]> {
  const peerKey = vaultPeerKey(vaultId);
  const out: MessageRow[] = [];
  for (const row of rows) {
    if (row.deleted) {
      out.push({
        id: row.id,
        peerId: peerKey,
        from_id: userId,
        to_id: userId,
        created_at: row.created_at,
        plaintext: TOMBSTONE_ENVELOPE_PLAINTEXT,
        deleted: true,
        seenLocal: true,
      });
      continue;
    }
    try {
      const pt = decryptVaultMessage(b64ToU8(row.ciphertext), b64ToU8(row.nonce), vaultKey);
      out.push({
        id: row.id,
        peerId: peerKey,
        from_id: userId,
        to_id: userId,
        created_at: row.created_at,
        plaintext: pt,
        seenLocal: true,
      });
    } catch {
      /* skip corrupt row */
    }
  }
  return out;
}
